import React, { Component, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import { http } from '../helper';
import { BaseUrl } from '../common/config';
import CommonAlert from '../common/Commonalert';
import Sidebar from '../common/sidebar';
import ShowAlert from '../common/Showalert';
import { canAction } from '../common/permissionhelper';
const MODULE = 'manage_masterentry';
const EditDepot = () => {
    // Permission checks
    const canEdit = canAction(MODULE, 'edit');
    const isReadOnly = !canEdit; // if true, disable inputs and hide submit
    const [mainDepot, setMainDepot] = useState([]);
    const [subDepot, setSubDepot] = useState([]);
    const [premastervalue, setPreMastervalue] = useState([]);
    const [errors, setErrors] = useState({});
    const [alertPopup, setAlertPopup] = useState(false);
    const [alertMessage, setAlertMessage] = useState([]);
    const [alerterrorPopup, setAlertErrorPopup] = useState(false);
    const [alerterrMessage, setAlerterrMessage] = useState([]);
    const [depotList, setDepotList] = useState([]);
    const params = useParams();
    if (!sessionStorage.getItem("isLoggedIn"))
        window.location.href = '/';

    if (JSON.parse(sessionStorage.getItem('authData')) != '' && !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_masterentry')) {
        window.location.href = '/unauthorized';
    }

    useEffect(() => {

        var loginDetails = {};
        if (sessionStorage.getItem('authData')) {
            loginDetails = JSON.parse(sessionStorage.getItem('authData'));
        }
        let URL = BaseUrl + `admin/getdepot/${params.id}`;
        http.get(URL).then((response) => {
            let responseData = response.data.data[0];
            console.log(responseData)
            setMainDepot(responseData.mainDepot);
            setSubDepot(responseData.subDepot);


        }).catch((err) => {
            console.log(err);

        })

        let URL1 = BaseUrl + `admin/getdepots`;
        http.get(URL1).then((response) => {
            let responseData1 = response.data.data;

            setDepotList(responseData1);
        }).catch((err) => {
            console.log(err);
        })


    }, [])
    const routeChange = () => {
        window.location.href = `/depot`;
    }
    const btnsubmit = (e) => {
        e.preventDefault();
        if (isReadOnly) return;

        const isValid = formvalidation();



        if (isValid) {
            let payload = {
                mainDepot: mainDepot.trim(),
                subDepot: subDepot.trim(),
                id: params.id,
            };


            var loginDetails = {};
            if (sessionStorage.getItem('authData')) {
                loginDetails = JSON.parse(sessionStorage.getItem('authData'));
            }

            let URL = BaseUrl + "admin/editdepot";
            http.put(URL, payload).then(async (response) => {
                let responseData = response.data.data;
                if (response.data.success === true) {
                    setAlertPopup(true);
                    setAlertMessage(`Depot updated successfully`);
                    setTimeout(() => {
                        routeChange();
                    }, 2000);

                }
            }).catch((err) => {
                console.log(err);

            })

        }

    }

    const formvalidation = () => {
        const errmsg = {};
        let isValid = true;
        const hasDupicateEntry = depotList.filter(dataa=>dataa._id!= params.id).some(depot => (depot.mainDepot.toLowerCase() === mainDepot.trim().toLowerCase() && depot.subDepot.toLowerCase() === subDepot.trim().toLowerCase())); 
        // const hasMainDepot = depotList.filter(dataa=>dataa._id!= params.id).some(depot => depot.mainDepot === mainDepot.trim()); 
        // const hasSubDepot = depotList.filter(dataa=>dataa._id!= params.id).some(depot => depot.subDepot === subDepot.trim()); 

        if (!mainDepot.trim()) {
            errmsg.mainDepot = "This field is required";
            isValid = false;
        }
        if (!subDepot.trim()) {
            errmsg.subDepot = "This field is required";
            isValid = false;
        }
        if(hasDupicateEntry){
            var alertmsg='';
            alertmsg="This Main Depot and  Local Depot have already been added";
            setAlertErrorPopup(true);
            setAlerterrMessage(alertmsg); 
            isValid = false;
        }

        setErrors(errmsg);
        return isValid;
    };

    const handleOnChange = (e) => {
        const re = /^[a-zA-Z0-9-' &.]*$/;

        if (e.target.name === "mainDepot") {
            if (e.target.value === "" || re.test(e.target.value)) {
                setMainDepot(e.target.value);
            }
        }
        if (e.target.name === "subDepot") {
            if (e.target.value === "" || re.test(e.target.value)) {
                setSubDepot(e.target.value);
            }
        }
        const { name, value } = e.target;

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };
    return (

        <section className="dashboard-block">
            {alerterrorPopup && (<ShowAlert title='Alert' message={alerterrMessage} />)}
            {alertPopup && (<CommonAlert title='Alert' message={alertMessage} />)}
            <div className="dash-right">
                <Sidebar />
            </div>
            <div className="dash-left">
                <Header />
                <section className="cart-block">
                    <div className="container account-details">

                        <div className="right-table-outer-wrap">
                            <h1 className="checkout-title">{canEdit ? 'Edit Depot' : 'View Depot'}</h1>
                            <div className='form-field freeproduct-fieldset ingredients-fieldset form-container-xs'>
                                <form className='sectors-detail-form'>
                                    <div className="input-field">
                                        <label for="name">Main Depot</label>
                                        <input
                                            type="text"
                                            name="mainDepot"
                                            value={mainDepot}
                                            onChange={handleOnChange}
                                            readOnly={isReadOnly}
                                        />
                                        {errors.mainDepot && (
                                            <div className="error-msg">{errors.mainDepot}</div>
                                        )}
                                    </div>
                                    <div className="input-field">
                                        <label for="name">Local Depot</label>
                                        <input
                                            type="text"
                                            name="subDepot"
                                            value={subDepot}
                                            onChange={handleOnChange}
                                            readOnly={isReadOnly}
                                        />
                                        {errors.subDepot && (
                                            <div className="error-msg">{errors.subDepot}</div>
                                        )}
                                    </div>

                                    <div className='btnfield'>
                                        {canEdit && <button type="submit" name="btnsubmit" onClick={btnsubmit}>Submit</button>}
                                        <button type="button" onClick={routeChange}>Cancel</button>
                                    </div>


                                </form>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </section>

            </div>

        </section>
    )
}
export default EditDepot;